export function trackEvent(eventName: string, data?: any, user?: any) {
  if (!window.gtag) {
    return;
  }

  if (!user) {
    window.gtag('event', eventName, {
      ...(data || {}),
      'user_properties': {
        'internal_traffic': window.location.host !== 'paramaster.de',
        ...(data?.['user_properties'] || {})
      }
    });
    return;
  }

  window.gtag('event', eventName, data);
}

export function updateMachines(selection: any) {
  if (!window.gtag) {
    return;
  }

  const userMachines = (window.localStorage.getItem('paramaster_machines') || '').split(',').filter(m => !!m);
  if (!userMachines.includes(selection.maschine.fullLabel)) {
    userMachines.push(selection.maschine.fullLabel);
  }
  window.gtag('set', 'user_properties', {
    'user_maschinen': userMachines.join(',')
  });
  window.localStorage.setItem('paramaster_machines', userMachines.join(','));
}

function findInList(list: Array<any>, id: number, prop = 'international') {
  const value = list.find(item => item.id === id);

  return value?.[prop] || value?.['bezeichnung'] || '-';
}

export function updateFavorites(sessions: Array<any>, lists: any) {
  if (!window.gtag) {
    return;
  }

  try {
    const maschinen = sessions.filter(s => s.maschine).map(s => ({
      maschine: findInList(lists.maschine, s.maschine, 'fullLabel')
    })).map(({maschine}) => maschine);
    const werkstoffe = sessions.filter(s => s.werkstoff).map(s => ({
      werkstoff: findInList(lists.werkstoff, s.werkstoff)
    })).map(({werkstoff}) => werkstoff);

    window.gtag('set', 'user_properties', {
      'user_favoriten_maschinen': maschinen.join(','),
      'user_favoriten_werkstoff': werkstoffe.join(','),
    });
  } catch(err) {
    console.error(err);
  }
}

export function trackParamasterCalculate(selection: any, user: any) {
  try {
    updateMachines(selection);

    const params: any = {
      'paramaster_maschinenhersteller': selection.maschinenhersteller.name,
      'paramaster_maschine': selection.maschine.bezeichnung,
      'paramaster_bandbeschichtung': findInList(selection.bandbeschichtungenList, selection.bandbeschichtung),
      'paramaster_bandmaterialtyp': findInList(selection.bandmaterialienList, selection.bandmaterialtyp),
      'paramaster_werkstoff': selection.erzeugnis.werkstoff.bezeichnung,
      'paramaster_werkstoff_form': selection.erzeugnis.form,
      'paramaster_gefuegeart': findInList(selection.gefuegeartenList, selection.gefuegeart),
      'paramaster_kuehlungsart': findInList(selection.kuehlungsartenList, selection.kuehlungsart),
      'paramaster_leistungsvorgabe': findInList(selection.leistungsvorgabenList, selection.leistungsvorgabe),
      'paramaster_verguetungsart': findInList(selection.verguetungsartList, selection.verguetungsart),
      'paramaster_lagenschnitt': selection.lagenschnitt
    }

    if (selection.lagenschnitt) {
      params['paramaster_anzahl_lagen'] = selection.anzahlLagen;
      params['paramaster_anzahl_pro_lage'] = selection.anzahlProLage;
    }

    if (selection.erzeugnis.form === 5) {
      params['paramaster_traeger_typ'] = findInList(selection.traegerTypenList, selection.erzeugnis.traegerTyp);
      params['paramaster_traeger_abmessung'] = findInList(selection.traegerAbmessungenList, selection.erzeugnis.traegerAbmessung, 'abmessung');
    } else if ([2, 3].includes(selection.erzeugnis.form)) {
      params['paramaster_breite'] = selection.erzeugnis.durchmesser;
      params['paramaster_hoehe'] = selection.erzeugnis.hoehe;
    } else {
      params['paramaster_durchmesser'] = selection.erzeugnis.durchmesser;
    }

    trackEvent('paramaster_calculate', params, user);

    if (selection.vorhandenesSaegeband && selection.vorhandenesSaegebandAusfuehrung) {
      trackEvent('paramaster_calculate_parameter', {
        'paramaster_parameter_saegeband': selection.vorhandenesSaegeband.bezeichnung,
        'paramaster_parameter_verzahnung': selection.vorhandenesSaegebandAusfuehrung.label,
      }, user);
    }
  } catch(err) {
    console.error(err);
  }
}

export function trackFavItem(item: any, action: 'add' | 'remove', lists: any, user: any) {
  try {
    const params: any = {};

    if (item.werkstoff) {
      params['paramaster_werkstoff'] = findInList(lists.werkstoff, item.werkstoff);
    }
    
    if (item.maschine) {
      params['paramaster_maschine'] = findInList(lists.maschine, item.maschine);
    }
    
    if (item.maschinenhersteller) {
      params['paramaster_maschinenhersteller'] = findInList(lists.maschinenhersteller, item.maschine, 'label');
    }

    trackEvent(`paramaster_favorite_${action}`, params, user);
  }
  catch(err) {
    console.error(err);
  }
}

const costPerCutTracked: Array<any> = [];
export function trackCostPerCut(item: any, user: any) {
  try {
    if (costPerCutTracked.includes(item.level)) {
      return;
    }

    costPerCutTracked.push(item.level);
    trackEvent('paramaster_cost_per_cut', {
      'paramaster_level': item.level,
      'paramaster_maschinenkosten': item.maschinenkosten,
      'paramaster_kosten_pro_bediener': item.kostenProBediener,
      'paramaster_preis_pro_band': item.preisProBand,
      'paramaster_standflaeche': item.standflaeche,
      'paramaster_maschinen_pro_bediener': item.maschinenProBediender,
    }, user);
  } catch (err) {
    console.error(err);
  }
}